import { render, staticRenderFns } from "./SanteSeniors.vue?vue&type=template&id=9bb803a0&scoped=true&"
import script from "./SanteSeniors.vue?vue&type=script&lang=js&"
export * from "./SanteSeniors.vue?vue&type=script&lang=js&"
import style0 from "./SanteSeniors.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SanteSeniors.vue?vue&type=style&index=1&id=9bb803a0&lang=scss&scoped=true&"
import style2 from "./SanteSeniors.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb803a0",
  null
  
)

export default component.exports